(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hbt-marquee-engine"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hbt-marquee')) {
    customElements.define('hbt-marquee', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.viewport = this.querySelector('[data-hbt-viewport]');
        this.track = this.querySelector('[data-hbt-track]');
        this.original = this.querySelector('[data-hbt-original]');
        this.button = this.querySelector('[data-hbt-motion-toggle]');
        this.label = this.querySelector('[data-hbt-toggle-label]');
        if (!this.viewport || !this.original || !this.button) return;
        this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.dataset.autoplay !== 'true' || this.motionQuery.matches || Boolean(window.Shopify?.designMode);
        this.reduceOverride = false;
        this.hovered = false;
        this.focused = false;
        this.visible = false;
        this.speed = Math.max(8, Math.min(48, Number(this.dataset.speed) || 20));
        this.button.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          if (!this.userPaused && this.motionQuery.matches) {
            this.reduceOverride = true;
            this.refresh();
          }
          this.update();
        }, { signal });
        this.viewport.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse') {
            this.hovered = true;
            this.update();
          }
        }, { signal });
        this.viewport.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'mouse') {
            this.hovered = false;
            this.update();
          }
        }, { signal });
        this.viewport.addEventListener('pointerdown', () => this.pauseForBrowsing(), { signal, passive: true });
        this.viewport.addEventListener('wheel', (event) => {
          if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) this.pauseForBrowsing();
        }, { signal, passive: true });
        this.viewport.addEventListener('keydown', (event) => {
          if (['ArrowLeft', 'ArrowRight', 'Home', 'End', 'PageUp', 'PageDown'].includes(event.key)) this.pauseForBrowsing();
        }, { signal });
        this.viewport.addEventListener('focusin', () => {
          this.focused = true;
          this.update();
        }, { signal });
        this.viewport.addEventListener('focusout', () => {
          queueMicrotask(() => {
            this.focused = this.viewport.contains(document.activeElement);
            this.update();
          });
        }, { signal });
        document.addEventListener('visibilitychange', () => this.update(), { signal });
        this.motionQuery.addEventListener('change', () => {
          this.reduceOverride = false;
          if (this.motionQuery.matches) this.userPaused = true;
          this.refresh();
        }, { signal });
        this.resizeObserver = new ResizeObserver(() => this.refresh());
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.original);
        this.intersectionObserver = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          this.update();
        });
        this.intersectionObserver.observe(this.viewport);
        this.refresh();
      }

      refresh() {
        if (!this.isConnected || !this.original) return;
        this.querySelectorAll('[data-hbt-clone]').forEach((clone) => clone.remove());
        this.groupWidth = this.original.getBoundingClientRect().width;
        const hasItems = this.original.children.length > 0 && this.groupWidth > 0;
        this.button.hidden = !hasItems;
        if (hasItems && (!this.motionQuery.matches || this.reduceOverride)) {
          const count = Math.max(1, Math.ceil(this.viewport.clientWidth / this.groupWidth));
          for (let index = 0; index < count; index += 1) {
            const clone = this.original.cloneNode(true);
            clone.removeAttribute('data-hbt-original');
            clone.setAttribute('data-hbt-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            [clone, ...clone.querySelectorAll('*')].forEach((element) => {
              [...element.attributes].forEach((attribute) => {
                if (attribute.name === 'id' || attribute.name.startsWith('data-shopify')) element.removeAttribute(attribute.name);
              });
              if (element.matches('a, button, input, select, textarea, [tabindex]')) element.setAttribute('tabindex', '-1');
            });
            this.track.append(clone);
          }
        }
        this.position = this.groupWidth ? this.viewport.scrollLeft % this.groupWidth : 0;
        this.viewport.scrollLeft = this.position;
        this.update();
      }

      pauseForBrowsing() {
        this.userPaused = true;
        this.update();
      }

      canRun() {
        return this.isConnected && this.groupWidth > 0 && !this.userPaused && !this.hovered && !this.focused && this.visible && !document.hidden;
      }

      update() {
        if (!this.button) return;
        const text = this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel;
        this.label.textContent = text;
        this.button.title = text;
        this.dataset.hbtPaused = String(this.userPaused);
        this.dataset.hbtRunning = String(this.canRun());
        if (this.canRun()) {
          if (!this.frame) {
            this.position = this.viewport.scrollLeft;
            this.lastTime = null;
            this.frame = requestAnimationFrame((time) => this.tick(time));
          }
        } else {
          cancelAnimationFrame(this.frame);
          this.frame = null;
          this.lastTime = null;
        }
      }

      tick(time) {
        this.frame = null;
        if (!this.canRun()) return;
        if (this.lastTime !== null) {
          this.position += Math.min((time - this.lastTime) / 1000, 0.1) * this.speed;
          if (this.position >= this.groupWidth) this.position %= this.groupWidth;
          this.viewport.scrollLeft = this.position;
        }
        this.lastTime = time;
        this.frame = requestAnimationFrame((nextTime) => this.tick(nextTime));
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.abort?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
